import { Card, CardHeader, CardContent, Alert } from "@mui/material";
import { ReactElement } from "react";

import { jobFailed } from "~frontend/util/jobs";

import { CampaignForEditor } from "../types";
import ContactListPreview from "./ContactListPreview";
import JobResult from "./JobResult";

export default function JobComplete({
  campaign,
}: {
  campaign: CampaignForEditor;
}): ReactElement {
  const { failed, errorMessage } = jobFailed(campaign.contactImportJob!);

  function renderError() {
    return (
      <>
        <Alert severity="error">Import failed: {errorMessage}</Alert>
      </>
    );
  }

  function renderSuccess() {
    return <JobResult campaign={campaign} job={campaign.contactImportJob!} />;
  }

  return (
    <>
      <Card sx={{ mt: 2 }}>
        <CardHeader title={failed ? "Import Failed" : "List Summary"} />
        <CardContent>{failed ? renderError() : renderSuccess()}</CardContent>
      </Card>
      {campaign?.availableSampleContacts && (
        <ContactListPreview campaign={campaign} />
      )}
    </>
  );
}
